module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daysnowshowers-690859cc8d3a29ebd722585ed46edebd.png";